import { useInView } from 'react-intersection-observer'
import { TContentfulConfigurableTileList } from 'types/contentful/configurableTileList.types'
import ConfigurableCard from './ConfigurableCard'
import { ComponentPlaceholder } from './ComponentPlaceholder'

export default function ConfigurableTileList({
  backgroundColor,
  tiles,
  generateStatically = false,
}: TContentfulConfigurableTileList) {
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: '100px 0px',
  })

  if (tiles?.length < 1) {
    return null
  }

  return (
    <div ref={ref}>
      {generateStatically || inView ? (
        <>
          <div
            className={
              'font-mori grid items-center grid-cols-2 gap-4 lg:flex lg:items-center lg:justify-between lg:flex-row p-[24px] lg:px-[7%]'
            }
            style={{
              backgroundColor,
            }}
          >
            {tiles?.map((tile) => {
              if (tile.componentKey === 'configurableCard') {
                return (
                  <ConfigurableCard
                    className="mr-0 lg:mr-[6px] lg:max-w-xs"
                    {...tile}
                    key={tile.name}
                  />
                )
              }

              return null
            })}
          </div>
        </>
      ) : (
        <ComponentPlaceholder height={400} />
      )}
    </div>
  )
}
